import React, { useState, useEffect } from 'react';
import slideOne from "../../../components/Assets/images/4.jpg";
import slideTwo from "../../../components/Assets/images/6.jpg";
import slideThree from "../../../components/Assets/images/3.jpg";

const data = [
  {
    image: slideOne,
    alt: "Slide 1",
    title: "Unlock Your Full Potential with Smart Student Tools",
    description: "Discover a suite of innovative resources designed to enhance your learning experience, improve productivity, and streamline your studies. Perfect for students of all ages!",
  },
  {
    image: slideTwo,
    alt: "Slide 2",
    title: "Transform Your Study Habits Today!",
    description: "Engage with interactive tools that promote efficient note-taking, task management, and collaboration. Take control of your academic success with the right strategies at your fingertips!",
  },
  {
    image: slideThree,
    alt: "Slide 3",
    title: "Your Path to Academic Excellence Starts Here",
    description: "Equip yourself with powerful tools tailored for effective time management and organization. Achieve your goals while staying on top of deadlines and assignments effortlessly!",
  },
];

const Herobanner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % data.length);
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [data.length]);

  return (
    <div className="w-[100vw] h-[80vh] relative overflow-hidden">
      <div
        className="w-full h-full flex transition-transform duration-1000 ease-in-out"
        style={{
          transform: `translateX(-${currentIndex * 100}%)`,
        }}
      >
        {data.map((e, i) => (
          <div
            key={i}
            className="w-full h-full flex-shrink-0"
            style={{
              backgroundImage: ` url(${e.image})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          >
            <div className="grid grid-cols-1 lg:grid-cols-2 place-items-end h-full">
                <div className="flex flex-col justify-center items-start gap-1 px-4 md:px-2 md:py-2 bg-gray-900 bg-opacity-[60%] lg:col-start-2 h-fit rounded-tl-md rounded-bl-md">
                    <p className="text-lg lg:text-2xl font-bold text-white text-start">
                        {e.title}
                    </p>
                    <p className="text-lg w-full font-medium text-white text-start opacity-[60%]">
                    {e.description}
                    </p>
                </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Herobanner;
